import {Component, inject} from '@angular/core';
import {MatInputModule} from "@angular/material/input";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {AuthService} from "../services/auth.service";
import {MatFormFieldModule} from "@angular/material/form-field";

@Component({
  selector: 'app-login-screen',
  standalone: true,
  imports: [
    MatInputModule,
    ReactiveFormsModule,
    MatButtonModule,
    FormsModule,
    MatFormFieldModule
  ],
  templateUrl: './login-screen.component.html',
  styleUrl: './login-screen.component.css'
})
export class LoginScreenComponent {

  authService = inject(AuthService);
  email = '';
  password = '';

  async signInClicked() {
    await this.authService.signInWithMicrosoft();
  }

  signInWithEmail() {
    this.authService.signInWithEmail(this.email, this.password);
  }

  forgotPassword() {
    // todo add implementation
  }
}
